import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errorMessage(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export const money = (n, currency = "CAD") =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency, minimumFractionDigits: n % 1 ? 2 : 0 }).format(n || 0);

export const track = (event, payload = {}) => {
  window.dispatchEvent(new CustomEvent("kc:analytics", { detail: { event, ...payload, at: Date.now() } }));
  queue.push({ event, source: payload.source || null, path: window.location.pathname.replace(/\/[0-9a-f]{24}/g, "/:id"), value: typeof payload.total === "number" ? payload.total : null });
  clearTimeout(flushTimer); flushTimer = setTimeout(flush, 1500);
};
const queue = []; let flushTimer;
const flush = () => { if (!queue.length) return; const events = queue.splice(0, 20); api.post("/public/analytics", { events }).catch(() => {}); };
